import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { useToast } from '../hooks/useToast';
import { initializeGlobalErrorHandler } from '../utils/globalErrorHandler';
import { getSelectedTenant } from '../config/environment';

export const GlobalErrorHandlerInitializer: React.FC = () => {
  const logout = useStore((state) => state.logout);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const userProfile = useStore((state) => state.userProfile);

  useEffect(() => {
    const getUserInfo = () => {
      const selectedTenant = getSelectedTenant();
      return {
        userId: userProfile?.username,
        // Field is forwarded as `tenantName` to POST /api/client-errors;
        // backend resolves the FK via findByName, so the name (not the UUID) is required.
        tenantId: selectedTenant?.name,
      };
    };

    initializeGlobalErrorHandler(logout, navigate, showToast, getUserInfo).catch((error) => {
      console.error('Failed to initialize global error handler:', error);
    });
  }, [logout, navigate, showToast, userProfile]);

  // This component doesn't render anything
  return null;
}; 